;(window.HB = window.HB || {}).addArrayToParams = function (
  baseUrl,
  values,
  key,
) {
  const url = new URL(baseUrl, window.location.origin)
  const params = new URLSearchParams(url.search)

  values.forEach((value) => {
    params.append(`${key}[]`, value)
  })
  return `${url.pathname}?${params}`
}
